<template>
  <div class="pgheader">
    <div class="pgheader-select">
      <p @click="changNav(1)" :class="navIndex == 1 ? 'actives' : ''">
        {{ $t("h5page.paygame.text1") }}
      </p>
      <div>
        <p @click="changNav(2)" :class="navIndex == 2 ? 'actives' : ''">
          {{ $t("paygame.payHistory") }}
        </p>
        <img  @click="$router.push({ path: '/service/h5' })" src="@/assets/images/h5/icon13.png" alt="" />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["navIndex"],
  methods: {
    changNav(val) {
      if (val == this.navIndex) return false;
      this.$router.push({
        path: this.navIndex == 1 ? "/pay_h5/pg_record" : "/pay_h5",
      });
    },
  },
};
</script>
<style lang="scss" scoped>
$color_fonts: #444444;
$bg_color: #50bbe5;
.pgheader {
  width: 100%;
  height: auto;
  position: fixed;
  background: white;
  top: 0;
  margin-top: 0.48rem;
  &-select {
    position: relative;
    width: 92%;
    height: 0.56rem;
    margin: auto;
    display: flex;
    align-items: center;
    justify-content: center;
    border-bottom: 1px solid #eeeeee;

    div {
      width: auto;
      height: 100%;
      display: flex;
      align-items: center;
      margin-left: 0.3rem;
      img {
        width: 0.37rem;
        height: 0.37rem;
        margin-left: 0.2rem;
      }
    }
    p {
      position: relative;
      width: auto;
      height: 100%;
      line-height: 0.63rem;
      font-size: 0.15rem;
      font-family: SourceHanSansCN;
      font-weight: bold;
      color: #bdbdbd;
     
    }
    .actives {
      color: $color_fonts;
      &::after {
        content: "";
        position: absolute;
        bottom: 0;
        left: 50%;
        width: 0.85rem;
        height: 0.03rem;
        transform: translateX(-50%);
        background: $bg_color;
        border-radius: 0.02rem;
      }
    }
  }
}
</style>
